import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import SelectorField from './selector-field';
import './assignee-select-field/result';

export default Component('tr-assignee-select-field', {
  extends: [SelectorField],
  mixins: [eventListenerMixin],
  properties: {
    empty: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
      observer() {
        this.empty = this.selectedOptions.value === 'no-assignee';
      },
    },
  },

  ready() {
    this.result = this.querySelector('.selector-field-result');
    this.listenTo(this.result, 'click', this.handleResultClicked.bind(this));
    this.listenTo(this.list, 'tr-selector-field-list:closed', this.handleListClosed.bind(this));
  },

  notifyChange() {
    this.namespacedTrigger('change', {
      detail: this.selectedOptions,
      bubbles: true,
    });
  },

  handleListClosed() {
    this.list.setOptions(this.dataProvider.options);
  },

  handleResultClicked() {
    this.list.open();
  },
});
